import { render, staticRenderFns } from "./CartItems.vue?vue&type=template&id=705b5c7f&scoped=true&"
import script from "./CartItems.vue?vue&type=script&lang=js&"
export * from "./CartItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b5c7f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckoutCartItem: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/CartItem/index.vue').default,CheckoutPromoCode: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/PromoCode.vue').default})
